import React, { FC, useMemo, useRef, useState } from 'react';

import { DropDownOptions } from 'devextreme-react/cjs/autocomplete';
//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppFieldBox, AppGroup, AppRow } from 'components/appComponents';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox, SelectBox } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeTonarRateConfigurationMutation,
  useCreateTonarRateConfigurationMutation,
  useLazyGetTonarRateConfigurationDetailQuery,
} from 'bus/tonarRateConfiguration/service';
import { TonarRateConfigurationCreate } from 'bus/tonarRateConfiguration/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  id: number | null;
  materialId: number | null;
};

const initialForm: TonarRateConfigurationCreate = {
  dateBegin: new Date(),
  factoryId: null,
  nomenclatureId: null,
  rate: 0,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, visible, materialId, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<TonarRateConfigurationCreate>(initialForm);

  const [getDetail] = useLazyGetTonarRateConfigurationDetailQuery();
  const [create, { isLoading: isLoadingCreate }] = useCreateTonarRateConfigurationMutation();
  const [change, { isLoading: isLoadingChange }] = useChangeTonarRateConfigurationMutation();

  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    if (id) {
      const result = await getDetail({ id }).unwrap();
      setForm({
        dateBegin: result.dateBegin,
        factoryId: result.factoryId,
        rate: result.rate,
        nomenclatureId: materialId,
      });
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await change({ ...form, id });
      } else {
        await create({ ...form, nomenclatureId: materialId! });
      }
      changeVisible(false);
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Материал"
        width={350}
        minHeight="auto"
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFieldBox label="Коэффициент" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format="###0.##"
                            value={form.rate}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, rate: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Коэффициент" />
                            </Validator>
                          </NumberBox>
                        </AppFieldBox>

                        <AppFieldBox label="Завод" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={factoryDataStore}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.factoryId}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, factoryId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Завод" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Завод" />
                            </Validator>
                          </SelectBox>
                        </AppFieldBox>

                        <AppFieldBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateBegin: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата" />
                            </Validator>
                          </DateBox>
                        </AppFieldBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
function getTonarRateConfigurationDetail(): [any, { isLoading: any }] {
  throw new Error('Function not implemented.');
}
